import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { UserDto } from "@/core/features/users/user.dto";
import { LimitedPermission } from "@altertec_gparn/lib";

export class ApiTokenDto extends BaseEntityDto {
  name: string;

  permissions: LimitedPermission[];

  isActive: boolean;

  token: string;

  @Type(() => UserDto)
  user: UserDto;
  userId: string;

  toString(): string {
    return this.name;
  }
}
